
  export default {
    layout: 'mainPage',
    transition: 'page',
    data () {
      return {
        teams: []
      }
    },
    head() {
      return {
        title: `${this.$t('aboutus.title')} - ICDC`
      }
    },
    mounted() {
      this.buildContent()
    },
    methods: {
      buildContent () {
        this.$t('aboutus.section3.teams').forEach(team => {
          const inputHTML = document.createElement('div')
          inputHTML.classList.add('row')
          inputHTML.classList.add('center-xs')
          const totalElements = team.members.length
          team.members.forEach((member, index) => {
            const divCol = document.createElement('div')
            const imageContent = document.createElement('div')
            const div = document.createElement('div')
            const image = document.createElement('img')
            const title = document.createElement('p')
            const rol = document.createElement('p')

            divCol.classList.add('text-center')
            divCol.classList.add('col-xs-12')
            divCol.classList.add('col-md-6')
            title.classList.add('text-bold')
            rol.classList.add('hide-xs-only')
            if ((index % 2 !== 0) && (totalElements > 3)) {
              divCol.classList.add('mt-6')
            }
            image.setAttribute('src', `${this.$t('aboutus.imagePath')}/${member.urlImage}`)
            image.setAttribute('alt', member.title)
            title.textContent = member.title
            rol.textContent = member.position
            div.appendChild(image)
            div.appendChild(title)
            div.appendChild(rol)
            imageContent.appendChild(div)
            divCol.appendChild(imageContent)
            inputHTML.appendChild(divCol)
          })

          const newTeam = {
            title: team.title,
            content: inputHTML
          }
          this.teams.push(newTeam)
        })
      }
    }
  }
